



import gsap from "gsap";

class Team {
  constructor() {
    this.init();
  }

  init() {
    const grid = document.querySelector('.team-grid');

    let initialHeight;

    if (window.innerWidth < 768 && document.querySelector('.team-container')) {

        if (document.querySelector('.team-member')) {
            const teamMembers = document.querySelectorAll('.team-member');
            teamMembers.forEach(function (teamMember, index) {
                if (index > 8) {
                    teamMember.classList.add('hidden');
                }
            });

            initialHeight = grid.offsetHeight - 62;
            gsap.set(grid, { height: initialHeight })
            teamMembers.forEach(function (teamMember, index) {
                teamMember.classList.remove('hidden');
            });
    
            const teamMore = document.querySelector('.team-more');
            if (teamMore) {
              teamMore.addEventListener('click', function (event) {
                  // teamMembers.forEach(function (teamMember) {
                    if (!teamMore.classList.contains('opened')) {
                      gsap.set(
                        grid,
                        {
                          height: 'auto',
                        }
                      );

                      teamMore.classList.add('opened');
                      teamMore.innerHTML = 'View Less';
                    } else {  
                      let teamContainer = document.querySelector('.team-container');

                      window.scrollTo({
                        top: teamContainer.offsetTop,
                        behavior: 'auto'
                      });
                      gsap.set(
                        grid,
                        {
                          height: initialHeight,
                        }
                      );
                      teamMore.classList.remove('opened');
                      teamMore.innerHTML = 'View All';
                    }
                  // });
              });
            }
        }
    }
  }

}

export default Team;


